export const MS_PER_MINUTE = 60000
